module.exports = __webpack_public_path__ + "5577b8e2d6beed82c4d6431e3935306b.svg";